import React from 'react';
import ActionsHeading from '../sharedComponents/ActionsHeading';
import List from '../sharedComponents/ActionList/List';

const HistoryLeftSection = () => {
  return (
    <React.Fragment>
      <ActionsHeading />
      <List />
    </React.Fragment>
  );
};

export default HistoryLeftSection;
